// aldoo-ra/AldooComponent/index.js
import { ComponentReader } from "./reader.js"

class AldooComponent {
  static addComponent(definition) {
    ComponentReader.registerComponent(definition)
    return this // Allow chaining
  }

  static getComponent(id) {
    return ComponentReader.getComponent(id)
  }

  static getComponents() {
    return ComponentReader.getComponents()
  }

  static getRegistry() {
    return ComponentReader.getRegistry()
  }

  static clear() {
    ComponentReader.clearCache()
  }

  static printRegistry() {
    const registry = ComponentReader.getRegistry()
    console.log('🧩 AldooComponent Registry:')
    if (registry.size === 0) {
      console.log('   No components registered')
    } else {
      registry.forEach((definition, id) => {
        console.log(`   📦 ${id}:`, {
          id: definition.id,
          component: definition.component?.name || 'Component',
          input: definition.input || {}
        })
      })
    }
    return registry
  }
}

// Export renderers
export { default as AldooPageRenderer } from './renderers/AldooPageRenderer.jsx'
export { default as AldooLayoutRenderer } from './renderers/AldooLayoutRenderer.jsx'
export { default as AldooSlotRenderer } from './renderers/AldooSlotRenderer.jsx'

// Export page routes utilities
export {
  fetchPages,
  buildRouteMap,
  loadPageRoutes,
  getPageByUrl,
  clearRoutesCache,
  getCachedRoutes,
} from './registry/page-routes.js'

// Export dynamic routes utilities
export {
  registerDynamicRoutes,
  clearDynamicRoutesFlag,
} from './registry/dynamic-routes.jsx'

// Export built-in components
export { default as HTMLContent } from '../HTMLContent/index.jsx'

export { ComponentReader }
export default AldooComponent